import React from 'react';

interface StatusIndicatorProps {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

const StatusIndicatorIcon = function StatusIndicatorIcon({
  className,
  width,
  height,
  color,
}: StatusIndicatorProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 27 27"
    >
      <circle cx="13.5" cy="13.5" r="13.5" fill={color} fillOpacity="0.15" />
      <circle cx="13.5" cy="13.5" r="10.5" fill={color} />
    </svg>
  );
};

StatusIndicatorIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
  color: '#ddd',
};

export default StatusIndicatorIcon;
